import { Skeleton } from "primereact/skeleton";
import { camelCase } from "lodash";

import { LessonCard } from "./LessonCard";
import LessonCardSkeleton from "./LessonCardSkeleton";
import type {
  ContentType,
  ContentStatus,
} from "sj-ui-toolkit/src/atlas/components/ContentCard/contentCardTypes";

interface Lesson {
  id: string | number;
  name: string;
  description?: string;
  duration?: number;
  durationNumber?: number;
  contentType?: string;
  lessonTypeFilter?: ContentType;
  lessonKey?: string;
  status?: ContentStatus;
  points?: number;
  required?: boolean;
  [key: string]: unknown;
}

interface LessonsContainerAdminProps {
  title: string;
  lessons: Lesson[];
  loading?: boolean;
}

const LessonsContainerAdmin = ({ title, lessons, loading = false }: LessonsContainerAdminProps) => {
  return (
    <div className="py-8">
      {loading ? (
        <Skeleton width="250px" height="24px" className="mb-4" />
      ) : (
        <h2 className="atlas-h5">{title}</h2>
      )}
      <div className="flex flex-wrap gap-6 mt-4">
        {loading ? (
          Array.from({ length: 12 }).map((_, i) => <LessonCardSkeleton key={i} />)
        ) : lessons.length === 0 ? (
          <p className="text-secondary body-sm">No lessons added to this path.</p>
        ) : (
          lessons.map((lesson, index) => (
            <LessonCard
              key={lesson.id ?? index}
              contentType={
                (camelCase(lesson.contentType ?? "") || lesson.lessonTypeFilter) as
                  | ContentType
                  | undefined
              }
              title={lesson.name}
              description={lesson.description}
              estimatedTime={lesson.durationNumber?.toString()}
              status={lesson.status}
              lessonKey={lesson.lessonKey}
              required={lesson.required}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default LessonsContainerAdmin;
